import React, { useState } from 'react';
import { defineMessages } from 'react-intl-next';

import { Card } from '../components/Card.tsx';
import { ConfluenceSmartCardProvider } from '@confluence/smart-card-provider/entry-points/ConfluenceSmartCardProvider.tsx';
import { useStoreOptions } from '@confluence/content-smartlinks/entry-points/useStoreOptions.ts';
import { isPageSSRd } from '@confluence/content-smartlinks/entry-points/isPageSSRd.ts';

import { LinkPickerButton } from './LinkPickerButton.tsx';
import { DocItem, type LinkData } from './LinkItem.tsx';

const i18n = defineMessages({
	topDocs: {
		id: 'space-overview.smart-space-overview.top-docs-card.title',
		defaultMessage: 'Top docs',
		description: 'Title of the top docs card',
	},
});

export const TopDocsCard = () => {
	const [links, setLinks] = useState<LinkData[]>([]);

	const maxCount = 4;
	const isAtCapacity = links.length >= maxCount;

	const handleAddLink = () => {};

	const handleLinkSubmit = (linkData: { url: string; title: string }) => {
		const newLink: LinkData = {
			id: `${linkData.url}-${linkData.title}`,
			url: linkData.url,
			title: linkData.title,
			subtitle: new URL(linkData.url).hostname,
		};

		setLinks((prevLinks) => [...prevLinks, newLink]);
	};

	const handleRemoveLink = (linkId: string) => {
		setLinks((prevLinks) => prevLinks.filter((link) => link.id !== linkId));
	};

	const handlePinLink = (_linkId: string) => {};

	const initialState = window['__SSR_TOP_DOCS__'];
	const storeData = useStoreOptions(initialState, isPageSSRd());
	const storeOptions = isPageSSRd() ? storeData : {};

	return (
		<ConfluenceSmartCardProvider authFlow="disabled" {...storeOptions}>
			<Card
				title={i18n.topDocs}
				count={links.length}
				maxCount={maxCount}
				actionButton={
					<LinkPickerButton
						onAddClick={handleAddLink}
						onLinkSubmit={handleLinkSubmit}
						disabled={isAtCapacity}
						existingLinks={links}
					/>
				}
			>
				{links.map((link) => (
					<DocItem key={link.id} link={link} onRemove={handleRemoveLink} onPin={handlePinLink} />
				))}
			</Card>
		</ConfluenceSmartCardProvider>
	);
};
